import { CNtoSupplierRoutes } from './SupplierAccountRoutesV2/CNtoSupplierRoutes';
import { DNtoSupplierRoutes } from './SupplierAccountRoutesV2/DNtoSupplierRoutes';
import { SupplierCNRoutes } from './SupplierAccountRoutesV2/SupplierCNRoutes';
import { SupplierInvoiceRoutes } from './SupplierAccountRoutesV2/SupplierInvoiceRoutes';
import { SupplierPaymentRoutes } from './SupplierAccountRoutesV2/SupplierPaymentRoutes';
import { SupplierDepositRoutes } from './SupplierAccountRoutesV2/SupplierDepositRoutes';
import { SupplierDNRoutes } from './SupplierAccountRoutesV2/SupplierDNRoutes';
import { SupplierInvoicesWithoutDORoutes } from './SupplierAccountRoutesV2/SupplierInvoicesWithoutDORoute';
import { BatchPaymentRoutes } from './SupplierAccountRoutesV2/BatchPaymentRoutes';
import { SupplierSelfBilledRoutes } from './SupplierAccountRoutesV2/SupplierSelfBilledRoutes';
import { InvoicetoSupplierRoutes } from './SupplierAccountRoutesV2/InvoiceToSupplierRoutes';
import { SupplierRefundRoutes } from './SupplierAccountRoutesV2/SupplierRefundRoutes';

const SupplierAccountRoutes = [
  ...SupplierDepositRoutes,
  ...SupplierCNRoutes,
  ...SupplierDNRoutes,
  ...SupplierInvoicesWithoutDORoutes,
  ...SupplierInvoiceRoutes,
  ...SupplierPaymentRoutes,
  ...SupplierRefundRoutes,
  ...DNtoSupplierRoutes,
  ...CNtoSupplierRoutes,
  ...BatchPaymentRoutes,
  ...InvoicetoSupplierRoutes,
  ...SupplierSelfBilledRoutes,
];

export default SupplierAccountRoutes;
